module.exports = __webpack_public_path__ + "static/MOD4-aa23ef20926df95cd80972c653bd2e33.jpg";